import { render, staticRenderFns } from "./EmptyCartModal.vue?vue&type=template&id=6c03a78b&scoped=true"
import script from "./EmptyCartModal.vue?vue&type=script&lang=js"
export * from "./EmptyCartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c03a78b",
  null
  
)

export default component.exports